// These constants allow communication between the monolith and the micro frontends
// These constants are used as session storage keys
// If you need to change these constants, please ensure you also update all relevant micro frontends
// Contact the FEFO team if you require more information or assistance

// deepcode ignore HardcodedNonCryptoSecret - key name
export const ADD_TO_FAVOURITES_POST_AUTHENTICATION_KEY = 'wtr_itemToFavouritePostAuthentication';
// deepcode ignore HardcodedNonCryptoSecret - key name
export const ADD_TO_TROLLEY_POST_AUTHENTICATION_KEY = 'wtr_itemToAddToTrolleyPostAuthentication';
